import atolyeApi from '@/api/atolye';

const state = {
  atolyeler: [],
  balances: [],
  canView: false,
};

const getters = {
  atolyeler: (s) => s.atolyeler,
  balances: (s) => s.balances,
  canViewAtolye: (s) => s.canView,
};

const actions = {
  async getAtolyeler({ commit }) {
    const { data } = await atolyeApi.getAtolyeler();
    commit('setAtolyeler', data || []);
    return data || [];
  },
  async createAtolye(_ctx, payload) {
    const { data } = await atolyeApi.createAtolye(payload);
    return data;
  },
  async updateAtolye(_ctx, { id, payload }) {
    const { data } = await atolyeApi.updateAtolye(id, payload);
    return data;
  },
  async deleteAtolye(_ctx, id) {
    await atolyeApi.deleteAtolye(id);
  },
  async getCanView({ commit }) {
    try {
      const { data } = await atolyeApi.canView();
      commit('setCanView', !!data);
      return !!data;
    } catch (e) {
      commit('setCanView', false);
      return false;
    }
  },
  async getBalances({ commit }) {
    const { data } = await atolyeApi.getBalances();
    commit('setBalances', data || []);
    return data || [];
  },
  async getMovements(_ctx, payload) {
    const p = payload || {};
    const { data } = await atolyeApi.getMovements(p.atolyeId, p.startDate, p.endDate, p.barcode);
    return data || [];
  },
  async sendGold(_ctx, payload) {
    const { data } = await atolyeApi.sendGold(payload);
    return data;
  },
  async receiveProduct(_ctx, payload) {
    const { data } = await atolyeApi.receiveProduct(payload);
    return data;
  },
};

const mutations = {
  setAtolyeler: (s, v) => { s.atolyeler = v; },
  setBalances: (s, v) => { s.balances = v; },
  setCanView: (s, v) => { s.canView = v; },
};

export default { namespaced: true, state, getters, actions, mutations };
